import './alert-message.scss';

import { kebabCase } from 'lodash';
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

export enum AlertMessageType {
  DEFAULT = 'DEFAULT',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

type AlertMessageProps = {
  type?: AlertMessageType;
  message: JSX.Element | string;
  autoClose?: number | false;
  onClose?: () => void;
};

export function AlertMessage({
  type = AlertMessageType.DEFAULT,
  message,
  autoClose = 3000,
  onClose,
}: AlertMessageProps) {
  const container = document.getElementById('alert-messages-container');

  const [active, setActive] = useState<boolean | null>(null);

  useEffect(() => {
    if (active === null) {
      setTimeout(() => {
        setActive(true);
      }, 100);
    }
  });

  useEffect(() => {
    if (autoClose) {
      setTimeout(() => {
        setActive(false);

        setTimeout(() => {
          onClose?.();
        }, 250);
      }, autoClose + 100);
    }
  }, [autoClose, onClose]);

  if (!container) return null;

  return ReactDOM.createPortal(
    <div
      className={`alert-message alert-message--${kebabCase(type)}${
        active ? ' active' : ''
      }`}
    >
      <p>{message}</p>

      {autoClose && (
        <div
          className="auto-close-loader"
          style={{ transitionDuration: `${autoClose + 100}ms` }}
        />
      )}
    </div>,
    container
  );
}
